import React from 'react';
import { Card } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';

interface LoadingStateProps {}

/**
 * Component to display a loading state with skeletons
 */
export const LoadingState: React.FC<LoadingStateProps> = () => {
  return (
    <div className="container max-w-7xl mx-auto py-6 px-6">
      <div className="flex items-center justify-between mb-5">
        <div className="flex items-center text-sm text-muted-foreground">
          <Skeleton className="h-6 w-24" />
        </div>
      </div>

      <div className="mb-6 pb-5 border-b">
        <Skeleton className="h-8 w-2/3 mb-3" />
        <div className="flex gap-2 mb-2">
          <Skeleton className="h-6 w-20" />
          <Skeleton className="h-6 w-32" />
        </div>
        <Skeleton className="h-4 w-full mt-3" />
      </div>

      <Card className="shadow-md border-muted">
        <div className="border-b">
          <div className="px-6 pt-4 pb-2 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
            <Skeleton className="h-10 w-64" />
          </div>
        </div>

        <div className="p-6">
          <div className="space-y-5">
            {[1, 2, 3].map((i) => (
              <div key={i} className="border rounded-md p-4">
                <Skeleton className="h-5 w-1/4 mb-2" />
                <Skeleton className="h-4 w-full" />
                <Skeleton className="h-16 w-full mt-2" />
              </div>
            ))}
          </div>
        </div>
      </Card>
    </div>
  );
};

export default LoadingState;
